declare global {
  interface Window {
    CLOUDPHONE_CONFIG?: { apiUrl?: string };
  }
}

// Set by /config.js (generated from API_PUBLIC_URL when the web container starts).
// VITE_API_URL is only for `npm run dev`.
export const apiUrl: string = (
  window.CLOUDPHONE_CONFIG?.apiUrl ||
  import.meta.env.VITE_API_URL ||
  'http://localhost:8081'
).replace(/\/+$/, '');
